import axios from 'axios';

export function fetchEvents(filter) {
    let parameters = '';

    if(filter !== undefined) {
        parameters = buildOptionalParametersArray(filter).join('&');
    }

    if(parameters !== '') {
        parameters = '?' + parameters;
    }

    return axios.get(getBaseUrl() + 'api/events' + parameters);
}

export function fetchCategories() {
    return axios.get(getBaseUrl() + 'api/categories');
}

export function fetchAdditionalCategories() {
    return axios.get(getBaseUrl() + 'api/additionalCategories');
}

export function getBaseUrl() {
    if(process.env.NODE_ENV === 'development') {
        return 'https://nezzoagendamaster.dev05.nezzobeta.ch/' + getLanguageKey();
    } else {
        return window.nezzoagenda_baseurl + '/';
    }
}

function getLanguageKey() {
    const languageKey = window.nezzoagenda_language;

    return languageKey === 'de' || languageKey === undefined ? '' : languageKey + '/';
}

export function buildOptionalParametersArray(filter) {
    let parametersArray = [];

    if(filter.search !== '') {
        parametersArray.push('search=' + filter.search);
    }

    if(filter.date !== null) {
        const formattedDate = filter.date.getDate() + '-' + (parseInt(filter.date.getMonth(), 10) + 1) + '-' + filter.date.getFullYear();
        parametersArray.push('date=' + formattedDate)
    }

    if(filter.categories !== null && filter.categories.length !== 0) {
        parametersArray.push('categories=' + filter.categories.map(item => item.value).join(','));
    }

    if(filter.additionalCategories !== null && filter.additionalCategories.length !== 0) {
        parametersArray.push('additionalCategories=' + filter.additionalCategories.map(item => item.value).join(','));
    }

    if(filter.limit !== 0) {
        parametersArray.push('limit=' + filter.limit);
    }

    return parametersArray;
}



// WEBPACK FOOTER //
// ./React/src/service/api.js